import { Dropdown } from "react-bootstrap";
import React, { Component } from 'react'
import styled from "styled-components";
import './customdropdown.css'

const DropdownStyle = styled.div`
	ul li {
		padding: 0px !important;
	}
	ul {
		padding: 5px 0px;
		z-index: 1;
	}
	.dropdown.btn-group {
		margin-top: 1px !important;
	}
`;

export default function CustomDropdown({ children, dropup = false, transparent, iconSize, ...props }) {
	return (
		<DropdownStyle {...props}>
			<Dropdown
				dropup={dropup}
				id="dropdown-engage"
				pullRight
				style={{ marginTop: "0px" }}
			>
				<DropdownToggle bsRole="toggle">
					<button className="customdropdown__white-btn" style={transparent?{background: 'transparent'}:{}}>
						<span className="material-symbols-outlined customdropdown__white-btn-text" style={{fontSize: iconSize}}>more_vert</span>
					</button>
				</DropdownToggle>
				<Dropdown.Menu>{children}</Dropdown.Menu>
			</Dropdown>
		</DropdownStyle>
	);
}
class DropdownToggle extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();

    this.props.onClick(e);
  }

  render() {
    return <div onClick={this.handleClick}>{this.props.children}</div>;
  }
}




// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/CustomDropdown/index.js